// removed by extract-text-webpack-plugin
module.exports = {"Websites":"Websites--1lLI6"};